// extracted by css-extract-rspack-plugin
export default {"dotsWrapper":"_a3b92463"};